module.exports = __webpack_public_path__ + "static/media/service1.8c40564f.webp";